export enum PublishStatusEnum {
  CANCEL = 1,
  WAIT,
  SUCC,
}

export const PublishStatusMap = new Map([
  [PublishStatusEnum.CANCEL, '已取消'],
  [PublishStatusEnum.WAIT, '等待发送'],
  [PublishStatusEnum.SUCC, '已发送'],
]);

export enum UserEnum {
  '全部用户',
  // '首登新用户',
  '7天内未登录用户' = 2,
  '30天内未登录用户',
  // '周活用户',
  // '未参与过活动的用户' = 5,
  'IOS用户' = 7,
  'Android用户' = 8,
}

/**
 * 跳转类型枚举
 *
 * 5/8 是后台运营手配通知用; 6/7 (用户主页/评论锚定) 是系统自动通知场景, 不暴露给运营
 */
export enum JumpTypeEnum {
  NO_JUMP = 0, // 无跳转
  MALL = 1, // 商城页
  NEWCOMER_CONTEST = 2, // 新人王参赛页 (tabbar)
  MEMBER_RECHARGE = 3, // 会员充值页
  COIN_RECHARGE = 4, // 金币充值页
  ARTWORK_DETAIL = 5, // 作品详情页 (需填 artworkId)
  CHALLENGE_DETAIL = 8, // 挑战赛详情页 (需填 bizId/contestId)
}

/**
 * 跳转类型映射
 */
export const JumpTypeMap = new Map([
  [JumpTypeEnum.NO_JUMP, '无跳转'],
  [JumpTypeEnum.MALL, '商城页'],
  [JumpTypeEnum.NEWCOMER_CONTEST, '新人王参赛页'],
  [JumpTypeEnum.MEMBER_RECHARGE, '会员充值页'],
  [JumpTypeEnum.COIN_RECHARGE, '金币充值页'],
  [JumpTypeEnum.ARTWORK_DETAIL, '作品详情页'],
  [JumpTypeEnum.CHALLENGE_DETAIL, '挑战赛详情页'],
]);
